
import { getLocationByPassPort } from '@/api/user.js'
import config from '@/config'
export default {
  data() {
    return {
      src: '',
      modelForm: {}, 
      loading: false, 
      dialogVisible: false,
      setTime: null
    }
  },
  methods: {
    async showPop() {
        if (this.setTime) {
            clearInterval(this.setTime)
            this.setTime = null
        }
        this.dialogVisible = true        
        fetch(`${config.SSR_API_URL}passport/miniprogramCode?type=getLocation`)
        .then(async (response) => {
          // 获取 header 值
          const headerValue = response.headers.get('x-scene');
          // debugger
          this.headerValue = headerValue
          const bloc = await response.blob()
          this.src = URL.createObjectURL(bloc)          
          this.setTime = setInterval( () => {
            getLocationByPassPort({scene: headerValue}).then( res => {                
                if (res.data && res.data.address) {
                    this.hidePop()
                    this.$emit('getLocationByPassPort', {  location: `${res.data.longitude},${res.data.latitude}`, address: res.data.address })
                }
            })

        }, 3000)                 
        })
             
    },
    hidePop() {
        if (this.setTime) {
            clearInterval(this.setTime)
            this.setTime = null
        }
        this.dialogVisible = false
    }
  }
}
